/*
  VINWEAR card swatches (agreement 5.x)

  On a product card, clicking an ink swatch used to load that livery's product
  page, because each livery is a separate product and the swatch is a real link.
  The reference site swaps the thumbnail in place instead, so shoppers can look
  through the colours without paying for a page load each time.

  This intercepts the click and updates the card - image, alt text, title, price
  and the card's own link - so the card now represents the livery being shown.
  Clicking the card afterwards goes to the right product.

  It is an enhancement layered on working links: without JavaScript, or on a
  middle-click or ctrl-click, the link behaves normally and still navigates.
*/
(function () {
  function cardOf(el) {
    return el.closest('.card-wrapper, .product-card-wrapper, .grid__item');
  }

  function apply(swatch) {
    var card = cardOf(swatch);
    if (!card) return;

    var img = card.querySelector('.card__media img, .card__inner img');
    if (img) {
      var src = swatch.getAttribute('data-vw-img');
      var srcset = swatch.getAttribute('data-vw-srcset');
      var alt = swatch.getAttribute('data-vw-alt');
      // Set srcset first: with src set alone the browser may keep resolving the
      // old srcset and paint the previous colour back.
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
      if (alt) img.setAttribute('alt', alt);
    }

    var href = swatch.getAttribute('href');
    var title = swatch.getAttribute('data-vw-title');

    // Dawn prints the card heading TWICE: a visually-hidden 0x0 copy inside the
    // media block (for screen readers) and the real one in .card__information.
    // querySelector returns the hidden one first, so updating that left the
    // visible title stale while image, price and swatch all changed. Update
    // every heading link, and drive the title from the one shoppers can see.
    var headings = [].slice.call(card.querySelectorAll('.card__heading a, a.full-unstyled-link'));
    var heading = headings.filter(function (h) {
      var r = h.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    })[0] || headings[0];
    if (headings.length && href) {
      headings.forEach(function (h) {
        h.setAttribute('href', href);
        if (title) h.textContent = title;
      });
    }

    // Any other link on the card pointing at the old product follows along, so
    // the whole tile stays consistent with what is on screen.
    if (href) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (!a.hasAttribute('data-vw-swatch')) a.setAttribute('href', href);
      });
    }

    // Prices can differ between liveries, so a stale price would be a lie.
    var price = swatch.getAttribute('data-vw-price');
    var priceEl = card.querySelector('.price-item--regular, .price__regular .price-item');
    if (price && priceEl) priceEl.textContent = price;

    card.querySelectorAll('[data-vw-swatch]').forEach(function (s) {
      s.classList.remove('vw-sw--on');
      s.removeAttribute('aria-current');
    });
    swatch.classList.add('vw-sw--on');
    swatch.setAttribute('aria-current', 'true');
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-vw-swatch]');
    if (!swatch) return;

    // Let the shopper open a livery in a new tab or window if they mean to.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    event.preventDefault();
    // The card sits under a full-tile overlay link; without this the card link
    // fires straight after and navigates anyway.
    event.stopPropagation();
    apply(swatch);
  });
})();
